export default __webpack_public_path__ + "static/media/bg.9a09a44d.jpg";